import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import Cookies from "js-cookie";
import { RetryOnError, verifyToken } from "../utils/VerifyToken";
import { checkForAuthorization } from "utils/index";

// export const FetchPipelineInvestors = ({ id, value, page = 1, limit = 10, sort = -1 }) => {
//     // console.log(id,"id")
//     // console.log(page.page,page.search,"page")
//     return useQuery(
//         ['master-listing-template-all-investors-rounds-fetch' + id + value, id, value, page, limit, sort],
//         () => {
//             let dynamicUrl = value === "invited" ? "getInvitePipelineInvestor" : "getPipelineInvestor";
//             return axios({
//                 method: 'get',
//                 url: `${process.env.REACT_APP_BASE_URL}/startups/${dynamicUrl}/${id}?page=${page}&limit=${limit}${sort != 0 ? `&sort=${sort}` : ''}`,
//                 headers: {
//                     'Authorization': `Bearer ${checkForAuthorization()}`
//                 },
//             })
//         }, {
//         // select: (data) => data,
//         select: (data) => {
//             console.log(data.data, "data")
//             return {
//                 data: data?.data?.data != undefined && data?.data?.data?.length > 0 ? data?.data?.data?.map(item => {
//                     // console.log(String(item?.investor_type)?.toLowerCase()?.includes("angel"), "fff")
//                     return ({
//                         ...item,
//                         name: item?.investor_type ? String(item?.investor_type)?.toLowerCase()?.includes("angel") ? item?.name : item?.organization_name : item?.name,
//                         //     // name: item?.investor_type ? String(item?.investor_type)?.toLowerCase()?.includes("angel") ? item?.personal_information : item?.organization_name : item?.personal_information,
//                         //     location: item?.city && item?.country ? `${item?.city},${item?.country}` : null,
//                         //     image: item?.profile_picture,
//                     })
//                 }) : [], count: data?.data?.count || 10, limit: data?.data?.limit || 10
//             }
//         },
//         refetchOnWindowFocus: false,
//         retry: (failureCount, error) => {
//             return RetryOnError(failureCount, error)
//         },
//         onError: (err) => {
//             return verifyToken(err)
//         },
//     })
// }

export const FetchPipelineInvestors = () => {
    return useMutation(
        ({ startup_id, value, page = 1, limit = 10, sort = -1, search = "", startup_round_id }) => {
            // console.log("Payload:", payload);
            // console.log("Startup ID:", startup_id);
            let dynamicUrl = value === "invited" ? "getInvitePipelineInvestor" : value === "interested" ? "getInterestedPipelineInvestor" : value === "rejected" ? "getRejectedPipelineInvestor" : value === "in-progress" ? "getInProgressPipelineInvestor" : "getInvitePipelineInvestor";
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/investors/${dynamicUrl}/${startup_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`,
                    'Content-Type': 'application/json'
                },
                // data: payload
                data: {
                    page: page,
                    limit: limit,
                    sort: sort,
                    search: search,
                    startup_round_id: startup_round_id
                    // value: value
                }
            })
        }, {
        // onSuccess: (data)=>console.log("API successfull"),
        // retry: (failureCount, error)=>{
        //   return RetryOnError(failureCount, error)
        // },
        retry: 0,
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const InviteInvestorToPipelineInvestors = () => {
    return useMutation(
        ({ payload, _id: startup_id }) => {
            // console.log("Payload:", payload);
            // console.log("Startup ID:", startup_id);
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/startups/pipelineInvestorInvite/${startup_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`,
                    'Content-Type': 'application/json'
                },
                data: payload
            })
        }, {
        // onSuccess: (data)=>console.log("API successfull"),
        // retry: (failureCount, error)=>{
        //   return RetryOnError(failureCount, error)
        // },
        retry: 0,
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const ChangePipelineInvestorStatus = () => {
    return useMutation(
        ({ payload, pipeline_id }) => {
            // console.log("Payload:", payload);
            // console.log("Startup ID:", pipeline_id);
            return axios({
                method: 'put',
                url: `${process.env.REACT_APP_BASE_URL}/startups/pipelineInvestorStatus/${pipeline_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`,
                    'Content-Type': 'application/json'
                },
                data: payload
            })
        }, {
        // onSuccess: (data)=>console.log("API successfull"),
        // retry: (failureCount, error)=>{
        //   return RetryOnError(failureCount, error)
        // },
        retry: 0,
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

//  add investor popup post api 
export const AddInvestorPopupPostApi = () => {
    return useMutation(
        ({ payload, _id }) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/startups/pipelineInvestorAdd/${_id}`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                data: payload,
                // onUploadProgress: (data) => {
                //     setProgress(Math.round((data.loaded / data.total) * 100) == 100 ? 99 : Math.round((data.loaded / data.total) * 100));
                // }
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};

//  edit investor popup post api 
export const EditInvestorPopupPostApi = () => {
    return useMutation(
        ({ payload, _id }) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/startups/in-progress`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                data: payload,
                // onUploadProgress: (data) => {
                //     setProgress(Math.round((data.loaded / data.total) * 100) == 100 ? 99 : Math.round((data.loaded / data.total) * 100));
                // }
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};

//  edit investor popup post api 
export const UpdateInvestorSetting = () => {
    return useMutation(
        ({ payload, _id, investor_id, module, key }) => {
            return axios({
                method: 'put',
                url: `${process.env.REACT_APP_BASE_URL}/investors/setting/${investor_id}/${module}/${key}`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                data: payload,
                // onUploadProgress: (data) => {
                //     setProgress(Math.round((data.loaded / data.total) * 100) == 100 ? 99 : Math.round((data.loaded / data.total) * 100));
                // }
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};

export const FetchDealFlowConfig = () => {
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['master-listing-template-all-investor-types-fetch-all'],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/settings?config_type=investor_setting`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            return data?.data?.data[0]?.data
            // const result = data.data.data[0]?.config_values
            //     ?.map((item, index) => {
            //         return ({
            //             _id: item?._id,
            //             // ...item,
            //             label: item?.name,
            //             value: item?.code
            //             // style: { ...sectorStyles[index]?.style }
            //             // image_url: String(item?.image_url).replace("startups", "investors")
            //         })
            //     })
            // // console.log(result, "result")
            // return result;
        },
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const GetInvestorSetting = ({investor_id, module}) => {
    // console.log(page.page,page.search,"page")
    return useQuery(
        [`master-listing-template-all-investor-types-fetch-all/${module}`+ investor_id, investor_id, ],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/investors/setting/${investor_id}/${module}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            return data?.data
            // const result = data.data.data[0]?.config_values
            //     ?.map((item, index) => {
            //         return ({
            //             _id: item?._id,
            //             // ...item,
            //             label: item?.name,
            //             value: item?.code
            //             // style: { ...sectorStyles[index]?.style }
            //             // image_url: String(item?.image_url).replace("startups", "investors")
            //         })
            //     })
            // // console.log(result, "result")
            // return result;
        },
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}